// Configurations for different question types

export const graphicalStatementConfig = {
  extractExtraState: (selectedOptions) => {
    const { statement1, statement2 } = selectedOptions;
    return { statement1, statement2 };
  },
  getCorrectOptions: (question) => ({
    statement1: question.answer_statement1.replace(/^&/, ''),
    statement2: question.answer_statement2.replace(/^&/, ''),
  }),
  getWrongOptions: (question) => {
    const getWrongOption = (options, correctValue) => {
      return options.find((opt) => opt && opt !== correctValue) || '';
    };
    const statement1Options = Array.from(
      { length: 5 },
      (_, index) => question[`statement1_option${index + 1}`],
    );
    const statement2Options = Array.from(
      { length: 5 },
      (_, index) => question[`statement2_option${index + 1}`],
    );
    return {
      statement1: getWrongOption(statement1Options, question.answer_statement1).replace(/^&/, ''),
      statement2: getWrongOption(statement2Options, question.answer_statement2).replace(/^&/, ''),
    };
  },
};

export const multiSourceConfig = {
  extractExtraState: (selectedOptions) => {
    return { selectedOptions };
  },
  getCorrectOptions: (questionDetails) => {
    const isSingleChoice = questionDetails.is_single_choice;
    if (isSingleChoice) {
      const yesAnswers = Object.keys(questionDetails).filter(
        (key) =>
          key.startsWith('answer_') && questionDetails[key].trim().toLowerCase() === 'yes',
      );
      return yesAnswers.reduce((obj, key) => {
        obj[key] = 'yes';
        return obj;
      }, {});
    } else {
      return Object.keys(questionDetails).reduce((obj, key) => {
        if (key.startsWith('answer_')) {
          obj[key] = questionDetails[key].trim().toLowerCase();
        }
        return obj;
      }, {});
    }
  },
  getWrongOptions: (questionDetails) => {
    const isSingleChoice = questionDetails.is_single_choice;
    if (isSingleChoice) {
      const allAnswerKeys = Object.keys(questionDetails).filter((key) =>
        key.startsWith('answer_'),
      );
      const randomKey = allAnswerKeys[Math.floor(Math.random() * allAnswerKeys.length)];
      return { [randomKey]: 'yes' };
    } else {
      return Object.keys(questionDetails).reduce((obj, key) => {
        if (
          key.startsWith('answer_') &&
          questionDetails[key] &&
          questionDetails[key].trim() !== ''
        ) {
          const value = questionDetails[key].trim().toLowerCase();
          obj[key] = value === 'yes' ? 'no' : 'yes';
        }
        return obj;
      }, {});
    }
  },
};

export const twoStatementConfig = {
  extractExtraState: (selectedOptions) => {
    return { selectedOptions };
  },
  getCorrectOptions: (question) => {
    let selectedAnswer1 = '';
    let selectedAnswer2 = '';

    for (const key of Object.keys(question)) {
      if (question[key] === question.answer1) selectedAnswer1 = key;
      if (question[key] === question.answer2) selectedAnswer2 = key;
      if (selectedAnswer1 && selectedAnswer2) break;
    }

    return {
      selectedAnswer1,
      selectedAnswer2,
    };
  },
  getWrongOptions: (question) => {
    const wrongOptionKeys = Object.keys(question)
      .filter((key) => key.startsWith('option'))
      .filter((key) => question[key] !== question.answer1 && question[key] !== question.answer2)
      .slice(0, 2); // Get the first 2 wrong option KEYS

    return {
      selectedAnswer1: wrongOptionKeys[0],
      selectedAnswer2: wrongOptionKeys[1],
    };
  },
};

export const tableAnalysisTwoPartConfig = {
  extractExtraState: (selectedOptions) => {
    return { selectedOptions };
  },
  getCorrectOptions: (question) => {
    const options = {};
    Object.keys(question)
      .filter((key) => key.startsWith('answer'))
      .forEach((key) => {
        const value = question[key];
        if (value && value.trim() !== '') {
          const optionKey = key.replace('answer', 'option');
          options[optionKey] = value.trim().toLowerCase();
        }
      });
    return options;
  },
  getWrongOptions: (question) => {
    const options = {};
    Object.keys(question)
      .filter((key) => key.startsWith('answer'))
      .forEach((key) => {
        const value = question[key];
        if (value && value.trim() !== '') {
          const optionKey = key.replace('answer', 'option');
          options[optionKey] = value.trim().toLowerCase() === 'yes' ? 'no' : 'yes';
        }
      });
    return options;
  },
};


// WEBPACK FOOTER //
// ./src/Components-2025/IR/utils/questionConfigs.js